import { createSlice } from '@reduxjs/toolkit';

// Dynamic plan/feature config fetched from subscription-service — the
// Super-Admin-managed single source of truth (Phase 5), replacing the old
// hardcoded PLAN_FEATURES map. Keyed by plan code (BASIC/PRO/CUSTOM) so a
// CUSTOM-account workspace switch (Phase 5) can carry a different plan's
// config without re-fetching.
const initialState = {
  featuresByPlan: {},   // { BASIC: { manual_attendance: true, ... }, PRO: {...} }
  limitsByPlan: {},      // { BASIC: { employee_limit, lens_device_limit, company_limit }, ... }
  isLoaded: false,
};

const planConfigSlice = createSlice({
  name: 'planConfig',
  initialState,
  reducers: {
    setPlanFeatures: (state, action) => {
      const { plan, features } = action.payload;
      const { lens_device_limit, employee_limit, company_limit, ...flags } = features;
      state.featuresByPlan[plan] = flags;
      state.limitsByPlan[plan] = { lens_device_limit, employee_limit, company_limit };
      state.isLoaded = true;
    },
    clearPlanConfig: () => ({ ...initialState }),
  },
});

export const { setPlanFeatures, clearPlanConfig } = planConfigSlice.actions;
export default planConfigSlice.reducer;

export const selectPlanConfigLoaded = (state) => state.planConfig.isLoaded;
